import { Component, ViewChild } from '@angular/core'
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, FeatureType } from '../../shared'
import { VistaUploadsDashboardComponent } from './vista-uploads-dashboard.component'
import { VistaUploadsListComponent } from './vista-uploads-list.component'

@Component({
    selector: 'app-vista-uploads',
    templateUrl: './vista-uploads.component.html',
    standalone: true,
    imports: [NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, VistaUploadsDashboardComponent, VistaUploadsListComponent],
})
export class VistaUploadsComponent extends BaseComponent {
    @ViewChild(VistaUploadsDashboardComponent)
    dashboard?: VistaUploadsDashboardComponent

    activeTab = 0

    constructor() {
        super()
        // Users without dashboard access land directly on the Records tab.
        this.activeTab = this.canViewDashboard ? 0 : 1
        this.initialLoadingComplete()
    }

    tabChanged() {
        if (this.isDashboardTab) {
            this.dashboard?.refresh()
        }
    }

    get canViewDashboard() {
        return this.services.authentication.hasFeature([FeatureType.AdminVistaUploadsDashboardView])
    }

    get isDashboardTab() {
        return Number(this.activeTab) === 0
    }

    get isRecordsTab() {
        return Number(this.activeTab) === 1
    }
}
